<template>
  <div>

    <table style="font-weight:normal !important; font-size: 12px;">
      <thead class="whf">
        <tr>

            <th class="wft" width="220px">{{ working_file.name }} <p  v-show="working_file.id !== null"  ></p></th>
            <th class="wft" width="100px" style="text-align:right">
              <money :amount="total_task_price" />
                 </th>
            <th class="wft" width="100px" style="text-align:right"><money :amount="total_stock_price" />
                </th>
            <th class="wft" width="100px" style="text-align:right">
              <money :amount="total_po_price" />
             </th>
            <th class="wft" width="100px" style="text-align:right">

              {{ working_file.qty }}</th>

            <th class="wdf" width="100px" style="text-align:right">
              <money :amount="total_cost_price" />
              </th>
              <th class="wdf" width="100px" style="text-align:right">
              <money :amount="total_sale_price" />
              </th>
              <th class="wdf" width="120px" style="text-align:right">
              <money :amount="  working_file.matched_quote" />
              </th>

            <th class="wdf" width="110px" style="text-align:right">T/C</th>
            <th class="wft" width="110px" style="text-align:right">T/C</th>
        <th width="80px" style="text-align:right">
              <el-popover
placement="right"
width="400"
trigger="click">

<el-row>
 <el-col  v-show="working_file.id !== null" :span="24" :xs="24" >
     Quantity:
     <input v-model.number="working_file.qty"
            step="1"
            type="number"
            @keypress.enter.prevent="prevent_enter"
            @change="update_qty"/>
   </el-col>
   <el-col  v-show="working_file.id !== null" :span="24" :xs="24" >
     Quantity Unit:
       <el-select v-model="quantity_unit_id"
                  class="block"
                  placeholder="Select"
                  :width="100"
                  @change="update_unit">
         <el-option
             v-for="quantity_unit in working_file.quantity_units"
             :key="quantity_unit.id"
             :label="quantity_unit.name"
             :value="quantity_unit.id">
         </el-option>
       </el-select>
   </el-col>
   <el-col  v-show="working_file.id !== null" :span="24" :xs="24" >
     Total(Matched quote):
     <input v-model.number="working_file.matched_quote"
            step="0.01"
            type="number"
            @keypress.enter.prevent="prevent_enter"
            @change="update_matched_quote"/>
   </el-col>
</el-row>
<el-row v-show="working_file.id !== null">

   Note
   <jodit-editor ref="note_editor" v-model="note_content"
                 :buttons="buttons"
                 id="working_file_note_editor"
                 :config="jodit_config"/>
 </el-row>


<el-button slot="reference"
circle
icon="el-icon-edit"></el-button>
</el-popover>
            </th>
          </tr>
            </thead>
            </table>





  </div>
</template>
<script>
import CommonJoditMixin from "mixins/CommonJoditMixin";
import Money from "components/shared/Money";

export default {
  name: "WorkingFile",
  mixins: [CommonJoditMixin],
  props: [ "working_file", "total_sale_price", "total_task_price", "total_stock_price", "total_po_price", "total_cost_price",],
  components: {
    Money
  },
  mounted() {
    this.quantity_unit_id = this.working_file.quantity_unit_id;
    if (this.working_file.id !== null) {
      this.note_content = this.working_file.note;
      this.$refs.note_editor.editor.events.on('outsideClick', this.update_note);
    }
  },
  data() {
    return {
      quantity_unit_id: null,
      note_content: "",
    }
  },
  methods: {
    update_note(e) {
      if(this.note_content !== this.working_file.note) {
        this.working_file.note = this.note_content;
        this.update_working_file({
          note: this.working_file.note
        });
      }
    },
    update_matched_quote() {
      this.update_working_file({
            matched_quote: this.working_file.matched_quote
          });
      this.$emit("changedTotal");
    },
    update_qty() {
      this.update_working_file({
        qty: this.working_file.qty
      });
    },
    update_unit(selected_id) {
      this.quantity_unit_id = this.working_file.quantity_unit_id = selected_id;
      this.update_working_file({
        quantity_unit_id: this.quantity_unit_id
      });
    },
    prevent_enter(e) {
      e.preventDefault();
      e.stopPropagation();
      e.target.blur();
    },
    update_working_file(params) {
      this.$http.patch(`/update_working_file_details/${this.working_file.id}`,
          {
            file_details: params
          })
          .then((response) => {
            this.$message({
              message: 'changed.',
              type: 'success'
            });
          }, (response) => {
            this.$message({
              type: "error",
              message: "Error happened while saving details.",
            });
          });
    }
  },

}
</script>

<style>
 th.wft {
  font-weight:normal;
  padding:0px;
 }
 th.wdf {

  padding:0px;
 }
 thead.whf{
  border:0px !important;
 }
</style>
